import { Quote } from '@client/model';
import {
  getProductDetailsSections,
  type ProductDetailEntry,
} from '@client/util/getProductDetailsSections';

type QuoteDetailSectionProps = {
  title: string;
  items: ProductDetailEntry[];
};

function QuoteDetailSection({ title, items }: QuoteDetailSectionProps) {
  return (
    <div className="select-none">
      <h4 className="text-primary-dark mb-2 text-sm font-bold">{title}</h4>
      <div className="space-y-1">
        {items.map((item, index) => (
          <p
            key={index}
            className="text-primary-dark/90 text-sm leading-relaxed"
            data-testid={item.testId}
          >
            {item.label && <span className="font-medium">{item.label}: </span>}
            {item.value}
          </p>
        ))}
      </div>
    </div>
  );
}

export function ProductDetails({ quote }: { quote: Quote }) {
  const sections = getProductDetailsSections(quote);

  return (
    <div className="mt-6">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {sections.map((section, index) => (
          <QuoteDetailSection
            key={index}
            title={section.title}
            items={section.items}
          />
        ))}
      </div>
    </div>
  );
}
